module.exports = __webpack_public_path__ + "assets/retina_3rdProportionalDetailed.4c708c6e73235748dcffaa416a28694a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_3rdProportionalDetailed.png
// module id = 600
// module chunks = 0